import React from 'react';
import ModernDrawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import close from '../../assets/close.svg';
const Drawer = ({ isOpen, toggleDrawer, children, className }) => {
    return (
        <ModernDrawer
            open={isOpen}
            onClose={toggleDrawer}
            direction="right"
            className={`${className} drawer-custom`}
            lockBackgroundScroll
            style={{ maxWidth: '640px', width: '100%', height: '100%' }}
        >
            <div className="flex flex-col h-full bg-white dark:bg-[#161b22]">
                <div className="flex justify-end pt-6 pr-6">
                    <img
                        onClick={toggleDrawer}
                        src={close || ''}
                        alt="close"
                        className="w-6 h-6 dark:invert opacity-70 dark:opacity-80 cursor-pointer hover:opacity-100"
                    />
                </div>
                <div className="flex-1 flex flex-col overflow-y-auto px-6 pb-6">
                    {children}
                </div>
            </div>
        </ModernDrawer>
    );
};

export default Drawer;
